/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { changementStatutSti } from '../fn/sti-controller/changement-statut-sti';
import { ChangementStatutSti$Params } from '../fn/sti-controller/changement-statut-sti';
import { getStiById } from '../fn/sti-controller/get-sti-by-id';
import { GetStiById$Params } from '../fn/sti-controller/get-sti-by-id';
import { getStis } from '../fn/sti-controller/get-stis';
import { GetStis$Params } from '../fn/sti-controller/get-stis';
import { StiDto } from '../models/sti-dto';

/**
 * Récupérer les stis.
 */
@Injectable({ providedIn: 'root' })
export class StiControllerApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `changementStatutSti()` */
  static readonly ChangementStatutStiPath = '/v2/stis/{idSti}/action';

  /**
   * put.
   *
   * Changement du statut de l'étape courante. Cas d'usage couverts : suspension, redemarrage, cloture etape courante
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `changementStatutSti()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  changementStatutSti$Response(
    params: ChangementStatutSti$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<{}>> {
    return changementStatutSti(this.http, this.rootUrl, params, context);
  }

  /**
   * put.
   *
   * Changement du statut de l'étape courante. Cas d'usage couverts : suspension, redemarrage, cloture etape courante
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `changementStatutSti$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  changementStatutSti(params: ChangementStatutSti$Params, context?: HttpContext): Observable<{}> {
    return this.changementStatutSti$Response(params, context).pipe(map((r: StrictHttpResponse<{}>): {} => r.body));
  }

  /** Path part for operation `getStis()` */
  static readonly GetStisPath = '/v2/stis';

  /**
   * get.
   *
   * Récuperer des STI
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getStis()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStis$Response(params: GetStis$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<StiDto>>> {
    return getStis(this.http, this.rootUrl, params, context);
  }

  /**
   * get.
   *
   * Récuperer des STI
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getStis$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStis(params: GetStis$Params, context?: HttpContext): Observable<Array<StiDto>> {
    return this.getStis$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<StiDto>>): Array<StiDto> => r.body)
    );
  }

  /** Path part for operation `getStiById()` */
  static readonly GetStiByIdPath = '/v2/stis/{idSti}';

  /**
   * get.
   *
   * Recupérer un STI
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getStiById()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStiById$Response(params: GetStiById$Params, context?: HttpContext): Observable<StrictHttpResponse<StiDto>> {
    return getStiById(this.http, this.rootUrl, params, context);
  }

  /**
   * get.
   *
   * Recupérer un STI
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getStiById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStiById(params: GetStiById$Params, context?: HttpContext): Observable<StiDto> {
    return this.getStiById$Response(params, context).pipe(map((r: StrictHttpResponse<StiDto>): StiDto => r.body));
  }
}
